module.exports = __webpack_public_path__ + "media/2500-1_YR_2022_Tailgating.8cf14ba9.mp4";